import { Component, OnInit, Input, ViewChild, Output } from '@angular/core';
import { TESTFICO } from './demo-ficoscores';
import { EventEmitter } from '@angular/core';



@Component({
  selector: 'app-demo-mode',
  templateUrl: './demo-mode.component.html',
  styleUrls: ['./demo-mode.component.scss']
})
export class DemoModeComponent implements OnInit {

  testfico = TESTFICO;

  @Output() selectDemoData = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  onChange(val) {

    // this.testfico.map(data => {
    //   data[val];
    // });
    const rTest = Object.assign({}, this.testfico[val]);
    this.selectDemoData.emit(rTest);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/demo-mode/demo-mode.component.ts